import React from 'react';
import ValidationTypes from 'lib/constants/validationTypes';
import withValidations from 'lib/hocs/withValidations';
import { FormattedMessage } from 'react-intl';
import { formatIdFromName } from 'lib/utility';

const FormCheckbox = ({ name, label, id, value, handleChange, required = true, useLocale = true, checked = false }) => (
  <div className="form-check">
    <input
      className="form-check-input"
      name={name}
      type="checkbox"
      value={value}
      checked={checked}
      onChange={handleChange}
      id={id || formatIdFromName(name)}
      data-testid={id || formatIdFromName(name)}
      required={required}
    />
    <label className="form-check-label" htmlFor={id || formatIdFromName(name)}>
      {useLocale ? <FormattedMessage {...label} /> : label.split('_').join(' ')}
    </label>
  </div>
);

export default withValidations({
  type: ValidationTypes.CUSTOM,
  required: true,
})(FormCheckbox);
